import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// packages/ui-common/src/components/error-boundaries/GlobalErrorBoundary.tsx
import { Component } from 'react';
export class GlobalErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleReset = () => {
            this.setState({
                hasError: false,
                error: null,
                errorInfo: null,
            });
        };
        this.handleGoHome = () => {
            window.location.href = '/';
        };
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        const errorContext = {
            appName: this.props.appName,
            message: error.message,
            stack: error.stack || '',
            componentStack: errorInfo.componentStack || '',
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            url: window.location.href,
            environment: process.env.NODE_ENV || 'development',
        };
        console.error(`[${this.props.appName}] Error caught:`, errorContext);
        if (this.props.firebaseDb) {
            this.logToFirestore(errorContext);
        }
    }
    async logToFirestore(errorContext) {
        try {
            const { firebaseDb } = this.props;
            const firestoreHelpers = window.__FIREBASE_FIRESTORE__;
            if (!firestoreHelpers) {
                console.error(`[${this.props.appName}] Firestore helpers not available`);
                return;
            }
            // ✅ FIX: Get userId from v9 Auth via window
            let userId;
            try {
                const authHelpers = window.__FIREBASE_AUTH__;
                userId = authHelpers?.currentUser?.uid;
            }
            catch {
                // Auth not available
            }
            const errorLog = {
                ...errorContext,
                userId: userId || null,
                resolved: false,
                occurrences: 1,
                createdAt: new Date(),
                updatedAt: new Date(),
            };
            const { collection, addDoc } = firestoreHelpers;
            const docRef = await addDoc(collection(firebaseDb, 'runtime_errors'), errorLog);
            console.log(`[${this.props.appName}] Error logged: ${docRef.id}`);
        }
        catch (firestoreError) {
            console.error(`[${this.props.appName}] Failed to log error:`, firestoreError?.message);
        }
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { style: {
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: this.props.appName === 'client' ? '#1a1a2e' : '#f3f4f6',
                    padding: '20px',
                }, children: _jsxs("div", { style: {
                        maxWidth: '500px',
                        width: '100%',
                        backgroundColor: this.props.appName === 'client' ? '#16213e' : '#ffffff',
                        borderRadius: '12px',
                        padding: '40px',
                        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center',
                    }, children: [_jsx("div", { style: { marginBottom: '24px' }, children: _jsxs("svg", { width: "64", height: "64", viewBox: "0 0 24 24", fill: "none", stroke: "#ef4444", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: { margin: '0 auto' }, children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("line", { x1: "12", y1: "8", x2: "12", y2: "12" }), _jsx("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })] }) }), _jsx("h1", { style: {
                                fontSize: '24px',
                                fontWeight: '600',
                                color: this.props.appName === 'client' ? '#ffffff' : '#1f2937',
                                marginBottom: '12px',
                            }, children: "\u26A0\uFE0F Something went wrong" }), _jsxs("p", { style: {
                                fontSize: '16px',
                                color: this.props.appName === 'client' ? '#9ca3af' : '#6b7280',
                                marginBottom: '32px',
                                lineHeight: '1.5',
                            }, children: ["The ", this.props.appName, " app encountered an error. Please try again or return home."] }), _jsxs("div", { style: { display: 'flex', gap: '12px', justifyContent: 'center' }, children: [_jsx("button", { onClick: this.handleReset, style: {
                                        padding: '12px 24px',
                                        backgroundColor: '#3b82f6',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                    }, children: "Try Again" }), _jsx("button", { onClick: this.handleGoHome, style: {
                                        padding: '12px 24px',
                                        backgroundColor: this.props.appName === 'client' ? '#374151' : '#e5e7eb',
                                        color: this.props.appName === 'client' ? '#ffffff' : '#1f2937',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                    }, children: "Go Home" })] }), process.env.NODE_ENV === 'development' && this.state.error && (_jsxs("details", { style: { marginTop: '24px', textAlign: 'left' }, children: [_jsx("summary", { style: {
                                        cursor: 'pointer',
                                        color: '#6b7280',
                                        fontSize: '14px',
                                        marginBottom: '8px',
                                    }, children: "Error Details (Dev Only)" }), _jsxs("pre", { style: {
                                        backgroundColor: '#1f2937',
                                        color: '#f3f4f6',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        overflow: 'auto',
                                        maxHeight: '200px',
                                    }, children: [this.state.error.message, '\n\n', this.state.error.stack] })] }))] }) }));
        }
        return this.props.children;
    }
}
